import { Stack, Typography } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedCurrencyValueInteger } from '../../../components/LocalizedCurrencyValueInteger';

interface NormalizeChartDataProps {
    data: number[];
    upperPartCoeff: number;
    heightCoeff: number;
    isMobile?: boolean;
}

export const normalizeChartData = ({ data, upperPartCoeff, heightCoeff, isMobile }: NormalizeChartDataProps) =>
    data.map((value, idx) => {
        const upperPartValue = value * upperPartCoeff;

        return {
            height: value * heightCoeff,
            upperPartValue: <LocalizedCurrencyValueInteger value={upperPartValue} />,
            upperPartHeight: upperPartValue * heightCoeff,
            label: (
                <Typography
                    textStyle={isMobile ? 'bodyExtraSmall' : 'bodyMedium'}
                    variant="secondary"
                    align="center"
                    as="div"
                >
                    <Stack vertical spacing="50">
                        <Stack>
                            <LocalizedText textKey={TextKey.Day} />
                            {UnicodeEntity.NoBreakSpace}
                            {idx + 1}
                        </Stack>
                        <LocalizedCurrencyValueInteger value={value} />
                    </Stack>
                </Typography>
            ),
            id: idx,
        };
    });
